import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import debounce from 'lodash/debounce';

import Kennitala from 'kennitala';
import moment from 'moment';
import { Services, Coupons, Discounts, Car, Vip, Statistics } from '../services/smartparking-api';
import queryString from 'querystring';

import { Header, Steps, Stats, Reviews, Section, Pricing, CarForm, Images } from '../components/ui';
import { toast } from 'react-toastify';

// Desing
import logo from '../assets/img/logo.svg';
import concept from '../assets/img/parking-concept-new.png';
import cover from '../assets/img/cover.jpg';
import bottom from '../assets/img/bottom.png';

import img1 from '../assets/img/lot1.png';
import img2 from '../assets/img/lot2.png';

// Material UI
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import cards from '../assets/img/kortalogo.png';

import Checkout from './Checkout';
import { Badge } from '@material-ui/core';

ReactGA.plugin.execute('ecommerce', 'addTransaction', {
    id: 'jd38je31j',
    revenue: '3.50',
});

// import { DateFormatInput, TimeFormatInput } from 'material-ui-next-pickers';

const formatISK = (price) =>
    Math.round(price)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

const carTypes = [
    { value: 'folksbill', label: 'Fólksbíll' },
    { value: 'jepplingur', label: 'Jepplingur' },
    { value: 'jeppi', label: 'Jeppi' },
    { value: 'yfirstaerd', label: 'Yfirstærð' },
];

// todo: dynamicly update services according to vehicle size and trip duration
class LandingPage extends Component {
    constructor(props) {
        super(props);
        let dates = {
            departure: new Date(),
            arrival: new Date(),
        };
        dates.arrival = new Date(dates.arrival.getTime() + 7 * 24 * 60 * 60 * 1000);

        this.state = {
            step: 0,
            maxStep: 0,
            // Car
            carNumber: localStorage.getItem('carNumber') || '',
            carSize: localStorage.getItem('carSize') || '',
            carMake: localStorage.getItem('carMake') || '',
            carType: localStorage.getItem('carType') || '',
            carColor: localStorage.getItem('carColor') || '',
            carError: '',
            specialNumber: false,
            // Client
            clientSSN: localStorage.getItem('clientSSN') || '',
            clientName: localStorage.getItem('clientName') || '',
            clientEmail: localStorage.getItem('clientEmail') || '',
            clientNumber: localStorage.getItem('clientNumber') || '',
            clientSenior: false,
            vipDiscount: 0,
            // Flight
            flightNumber: '',
            departureTime: '',
            departureDate: '',
            arrivalTime: '',
            arrivalDate: '',
            // Services
            tripDuration: 0,
            price: 0,
            fullPrice: 0,
            rates: {
                base: {
                    label: 'Grunngjald',
                    price: 5900,
                },
                daily: {
                    label: 'Daggjald',
                    price: 590,
                },
            },
            services: [],
            coupon: '',
            couponDiscount: 0,
            discountGroups: [],
            inCheckout: false,
            dateStats: null,
            overload: false,
        };

        if (this.state.carType) {
            this.populateServices();
        }
    }

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.pageView();
        // this.populateDiscounts();
        this.registerCoupon = debounce(this.registerCoupon, 800);

        const parsed = queryString.parse(this.props.location.search);
        !!parsed['?discount'] && this.handleCouponChange(parsed['?discount']);

        // Check seniority of stored SSN
        if (this.state.clientSSN.length === 10) this.handleSSN(this.state.clientSSN);

        Statistics.dates().then((val) => {
            this.setState({ dateStats: val.data });
            console.log(val.data);
        });
    }

    changeStep = (step) => step <= this.state.maxStep && this.setState({ step });

    // Car form
    handleCarSelection = (carNumber) => {
        if (!this.state.specialNumber && carNumber.length > 5) return;
        (carNumber.length <= 5 || this.state.specialNumber) && this.setState({ carNumber: carNumber.toUpperCase() });

        // add debounce! fyrir einkanúmer ( === 5 virkar ekki! )
        if (this.state.specialNumber) return;
        localStorage.setItem('carNumber', carNumber);
        localStorage.removeItem('carMake');
        localStorage.removeItem('carType');
        localStorage.removeItem('carColor');
        carNumber.length === 5
            ? Car.get(carNumber)
                  .then((res) => {
                      const { type, subType, color } = res.data;
                      this.setState(
                          {
                              carMake: type.split('-')[0].replace(/^\s+|\s+$/g, ''),
                              carType: subType.replace(/^\s+|\s+$/g, ''),
                              carColor: color,
                          },
                          () => {
                              const { carMake, carType, carColor } = this.state;
                              localStorage.setItem('carMake', carMake);
                              localStorage.setItem('carType', carType);
                              localStorage.setItem('carColor', carColor);
                          }
                      );
                  })
                  .catch((err) => this.setState({ carError: 'Bíll fannst ekki' }))
            : this.setState({ carMake: '', carType: '', carColor: '', carError: '' });
    };

    handleSizeSelection = (carSize) =>
        this.setState({ carSize }, () => {
            localStorage.setItem('carSize', carSize);
            this.populateServices();
        });

    handleMakeSelection = (carMake) => this.setState({ carMake }, () => localStorage.setItem('carMake', carMake));

    handleTypeSelection = (carType) => this.setState({ carType }, () => localStorage.setItem('carType', carType));

    handleColorSelection = (carColor) => this.setState({ carColor }, () => localStorage.setItem('carColor', carColor));

    submitCar = (e) => {
        e.preventDefault();
        // Validation
        const { carNumber, carSize, carMake, carType, carColor } = this.state;
        if (!carNumber) return toast.error('Það vantar bílnúmer!');
        if (!carSize) return toast.error('Það vantar bílstærð!');
        if (!carMake) return toast.error('Það vantar tegund bíls!');
        if (!carType) return toast.error('Það vantar týpu bíls!');
        if (!carColor) return toast.error('Það vantar lit bíls!');

        ReactGA.event({
            category: 'Order',
            action: 'submitCar',
        });

        this.setState({ step: 1, maxStep: 1 });
    };

    // Client form
    handleSSN = (ssn) => {
        let clientSenior = Kennitala.info(ssn).age >= 65 && Kennitala.isPerson(ssn);
        if (clientSenior) {
            const { coupon, couponDiscount } = this.state;
            if (coupon && couponDiscount < 10) {
                this.setState({ coupon: '', couponDiscount: 0 });
            }
        }

        this.setState({ clientSSN: ssn.replace(/\D/g, ''), clientSenior }, () => {
            // check for ssn discount
            this.state.clientSSN.length === 10
                ? Vip.getVipStatus(ssn)
                      .then((res) => {
                          if (res.data) {
                              toast.success(`Þú ert skráður VIP! Þú færð ${res.data.discount}% afslátt!`);
                              this.setState({ vipDiscount: res.data.discount });
                          }
                      })
                      .catch((err) => {
                          console.error(err);
                      })
                : this.setState({ vipDiscount: 0 });
            localStorage.setItem('clientSSN', this.state.clientSSN);
        });
    };

    submitClient = (e) => {
        e.preventDefault();

        const { clientSSN, clientName, clientEmail, clientNumber } = this.state;
        if (!clientSSN) return toast.error('Það vantar kennitölu!');
        if (!clientName) return toast.error('Það vantar bílstærð!');
        if (!clientEmail) return toast.error('Það vantar netfang!');
        if (!clientNumber) return toast.error('Það vantar símanúmer!');

        ReactGA.event({
            category: 'Order',
            action: 'submitClient',
        });

        this.setState({ step: 2, maxStep: 2 });
    };

    // Trip form
    submitTrip = (e) => {
        e.preventDefault();
        const { departureDate, departureTime, arrivalDate, arrivalTime, flightNumber, vipDiscount } = this.state;

        if (!departureDate) return toast.error('Það vantar brottfarardag!');
        if (!departureTime) return toast.error('Það vantar komutíma á leifsstöð!');
        if (!arrivalDate) return toast.error('Það vantar heimkomudag!');
        if (!arrivalTime) return toast.error('Það vantar heimkomutíma!');
        if (!flightNumber) return toast.error('Það vantar flugnúmer!');

        // if(moment(departureDate).diff(moment('16.04.2019')))

        const departure = moment(`${departureDate.format('YYYY-MM-DD')} ${departureTime.format('HH:mm:ss')}`);
        const arrival = moment(`${arrivalDate.format('YYYY-MM-DD')} ${arrivalTime.format('HH:mm:ss')}`);

        if (vipDiscount !== 100 && moment(departure).isBefore(moment())) return toast.error('Brottfaratími er liðinn');
        if (moment(arrival).isBefore(departure)) return toast.error('Brottfaratími má ekki vera á eftir heimkomutíma!');

        ReactGA.event({
            category: 'Order',
            action: 'submitTrip',
        });

        const duration = moment.duration(arrival.diff(departure));

        this.setState({ tripDuration: Math.ceil(duration.asHours() / 24), step: 3, maxStep: 3 }, () => this.updatePrice());
    };

    setDeparturedDate = (date) => {
        const { arrivalDate, departureTime, arrivalTime } = this.state;

        let tripDuration = 0;
        if (arrivalDate && departureTime && arrivalTime) {
            const departureDateTime = moment(`${date.format('YYYY-MM-DD')} ${departureTime.format('HH:mm:ss')}`);
            const arrivalDateTime = moment(`${arrivalDate.format('YYYY-MM-DD')} ${arrivalTime.format('HH:mm:ss')}`);
            const duration = moment.duration(arrivalDateTime.diff(departureDateTime));
            tripDuration = Math.ceil(duration.asHours() / 24);
        }

        this.setState(
            {
                departureDate: date,
                tripDuration,
            },
            () => this.updatePrice()
        );
    };

    setArrivalDate = (date) => {
        const { departureDate, departureTime, arrivalTime } = this.state;
        let tripDuration = 0;
        if (departureDate && departureTime && arrivalTime) {
            const departureDateTime = moment(`${departureDate.format('YYYY-MM-DD')} ${departureTime.format('HH:mm:ss')}`);
            const arrivalDateTime = moment(`${date.format('YYYY-MM-DD')} ${arrivalTime.format('HH:mm:ss')}`);
            const duration = moment.duration(arrivalDateTime.diff(departureDateTime));
            tripDuration = Math.ceil(duration.asHours() / 24);
        }
        this.setState(
            {
                arrivalDate: date,
                tripDuration,
            },
            () => this.updatePrice()
        );
    };

    // Service form
    submitServices = (e) => {
        e.preventDefault();
        ReactGA.event({
            category: 'Order',
            action: 'submitServices',
        });
        this.setState({ inCheckout: true });
    };

    handleServiceSelection = (index) => (event) => {
        const { services } = this.state;
        services[index].checked = event.target.checked;
        this.setState({ services }, () => this.updatePrice());
    };

    handleDiscountSelection = (i) => (event) => {
        const { discountGroups } = this.state;
        discountGroups.map((d, i) => (discountGroups[i].checked = false));
        discountGroups[i].checked = event.target.checked;
        this.setState({ discountGroups }, () => this.updatePrice());
    };

    handleCouponChange = (coupon) => {
        this.setState({ coupon });

        this.setState({ coupon, couponDiscount: 0 }, () => this.updatePrice());
        this.registerCoupon(coupon.trim());
    };

    registerCoupon = (text) => {
        const { coupon } = this.state;
        // if (coupon.length !== 5) return this.setState({ couponDiscount: 0 }, () => this.updatePrice());
        Coupons.checkCouponValidity(coupon)
            .then((res) => {
                if (res.data) {
                    this.setState({ couponDiscount: res.data.percentage }, () => this.updatePrice());
                    toast.success(`Vúhú! Þú færð ${res.data.percentage}% afslátt!`);
                } else {
                    this.setState({ couponDiscount: 0 }, () => this.updatePrice());
                    toast.error(`Því miður fannst enginn afsláttur á þessum kóða`);
                }
            })
            .catch((err) => {
                this.setState({ couponDiscount: 0 }, () => this.updatePrice());
                toast.error(`Því miður fannst enginn afsláttur á þessum kóða`);
            });
    };

    // Helpers
    updatePrice = (premia) => {
        const {
            tripDuration,
            services,
            rates,
            couponDiscount,
            clientSenior,
            vipDiscount,
            departureDate,
            dateStats,
            arrivalDate,
        } = this.state;
        // Base and services
        let price = tripDuration * rates.daily.price + rates.base.price;
        services.map((s) => (price += s.checked ? (s.daily ? s.price * tripDuration : s.price) : 0));
        let fullPrice = price;

        console.log(premia);
        const discount = Math.max(vipDiscount || 0, couponDiscount || 0, clientSenior ? 10 : 0, premia ? 25 : 0) || 0;
        console.log(discount);

        const applyDiscount = (discount, price) => {
            return Math.round((1 - discount / 100) * price);
        };

        if (discount) price = applyDiscount(discount, price);

        if (dateStats && vipDiscount !== 100) {
            const departureStats = dateStats.find((d) => moment(d.date).isSame(moment(departureDate), 'day'));
            const arrivalStats = dateStats.find((d) => moment(d.date).isSame(moment(arrivalDate), 'day'));

            if (departureStats && departureStats.overload) {
                price += fullPrice * 0.2;
                this.setState({ overload: true });
            } else if (arrivalStats && arrivalStats.overloadOut) {
                price += fullPrice * 0.2;
                this.setState({ overload: true });
            } else {
                this.setState({ overload: false });
            }
        }

        this.setState({ price, fullPrice });
    };

    cancelCheckout = () => {
        this.setState({ inCheckout: false });
    };

    // Api calls
    populateServices = () => {
        Services.getAllServicesBySize(this.state.carSize).then((val) => {
            this.setState({
                services: val.data.filter((s) => !!s.active).sort((a, b) => a.label.localeCompare(b.label)),
            });
        });
    };

    populateDiscounts = () => {
        Discounts.getClientDiscounts().then((val) => this.setState({ discountGroups: val.data.discountGroups }));
    };

    render() {
        const isIE = document.documentMode;
        if (isIE) {
            return (
                <div
                    style={{
                        background: '#015351',
                        height: '100vh',
                        width: '100%',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <p style={{ margin: 0 }}>
                        Bókunarkerfi <b>Lagningar</b> styður því miður ekki vafran Internet Explorer
                    </p>{' '}
                    <br />
                    <em style={{ margin: 0 }}>við hvetjum þig því til að nota Google Chrome, Firefox eða Safari</em>
                </div>
            );
        }

        const url = 'https://lagning.is/';
        const slogan = 'Góð geymsla fyrir bílinn á meðan þú ferðast. Njóttu einfaldar og fljótlegrar þjónustu Lagningar';
        const step = <Steps length={4} currentStep={this.state.step} onClick={this.changeStep.bind(this)} />;

        // CarForm
        const { carNumber, carSize, carMake, carType, carColor, carError } = this.state;
        const carValidation = carMake && carType && carColor && carSize;
        const helperText = carMake && carType && carColor ? `${carMake} - ${carType} (${carColor})` : carError;

        const carForm = (
            <CarForm
                carNumber={carNumber}
                carMake={carMake}
                carType={carType}
                carColor={carColor}
                carSize={carSize}
                handleCarSelection={this.handleCarSelection.bind(this)}
                handleSizeSelection={this.handleSizeSelection.bind(this)}
                handleMakeSelection={this.handleMakeSelection.bind(this)}
                handleTypeSelection={this.handleTypeSelection.bind(this)}
                handleColorSelection={this.handleColorSelection.bind(this)}
                specialNumber={this.state.specialNumber}
                toggleSpecialNumber={(e) =>
                    this.setState({
                        specialNumber: !this.state.specialNumber,
                        carNumber: '',
                    })
                }
                carValidation={carValidation}
                error={carError}
                helperText={helperText}
                step={step}
                submitFunction={this.submitCar.bind(this)}
            />
        );

        // ClientForm
        const { clientSSN, clientName, clientEmail, clientNumber, clientSenior, vipDiscount } = this.state;
        const clientDiscount = Math.max(vipDiscount || 0, clientSenior ? 10 : 0) || 0;
        const clientValidation =
            clientSSN.length === 10 && Kennitala.isValid(clientSSN) && clientName && clientEmail && clientNumber.length >= 7;

        let clientHelperText = null;

        if (clientSenior && clientDiscount === 10) {
            clientHelperText = 'Þú hlýtur 10% afslátt eldri borgara';
        } else if (vipDiscount && vipDiscount === clientDiscount) {
            clientHelperText = `Þú hlýtur ${vipDiscount}% VIP afslátt`;
        }

        const clientForm = (
            <form className="mainForm" onSubmit={this.submitClient}>
                <h2>Upplýsingar um þig</h2>
                {step}
                <TextField
                    autoFocus
                    id="ssn"
                    label="Kennitala Greiðanda"
                    placeholder="123456 1234"
                    margin="normal"
                    maxLength="10"
                    value={this.state.clientSSN}
                    onChange={(e) => this.handleSSN(e.target.value)}
                    helperText={clientHelperText}
                    className="mainInput"
                    tabIndex={3}
                />
                <TextField
                    id="name"
                    label="Nafn Ökumanns"
                    placeholder="Jón Jónsson"
                    margin="normal"
                    value={this.state.clientName}
                    onChange={(e) =>
                        this.setState({ clientName: e.target.value }, () =>
                            localStorage.setItem('clientName', this.state.clientName)
                        )
                    }
                    className="mainInput"
                    tabIndex={4}
                />
                <TextField
                    id="email"
                    type="email"
                    label="Netfang"
                    placeholder="jon@jonsson.is"
                    margin="normal"
                    value={this.state.clientEmail}
                    onChange={(e) =>
                        this.setState({ clientEmail: e.target.value }, () =>
                            localStorage.setItem('clientEmail', this.state.clientEmail)
                        )
                    }
                    className="mainInput"
                    tabIndex={5}
                />
                <TextField
                    id="number"
                    label="Símanúmer"
                    placeholder="581 2345"
                    margin="normal"
                    maxLength="7"
                    value={this.state.clientNumber}
                    onChange={(e) =>
                        this.setState({ clientNumber: e.target.value }, () =>
                            localStorage.setItem('clientNumber', this.state.clientNumber)
                        )
                    }
                    className="mainInput"
                    tabIndex={6}
                />
                <Button variant="contained" className={'mainButton'} disabled={!clientValidation} type="submit">
                    Halda áfram
                </Button>
            </form>
        );

        const { departureDate, departureTime, arrivalDate, arrivalTime, flightNumber } = this.state;
        const tripValidation = departureDate && departureTime;
        const tripForm = (
            <form className="mainForm" onSubmit={this.submitTrip}>
                <h2>Upplýsingar um ferðina</h2>
                {step}
                <div className="fullWidth">
                    <TextField
                        autoFocus
                        id="ssn"
                        label="Flugnúmer á heimleið ( mjög mikilvægt )"
                        placeholder="FI123"
                        margin="normal"
                        maxLength="10"
                        value={this.state.flightNumber}
                        onChange={(e) => this.setState({ flightNumber: e.target.value.toUpperCase() })}
                        className="mainInput"
                        helperText={'Með flugnúmerinu getum við fylgst með fluginu og gert allt tilbúið fyrir lendingu'}
                        tabIndex={1}
                    />
                </div>
                <div className="dateInputs">
                    <DatePicker
                        label="Brottfarardagur"
                        value={departureDate}
                        className="dateInput"
                        onChange={this.setDeparturedDate}
                        format={'DD.MM.YYYY'}
                        animateYearScrolling
                        autoOk={true}
                        okLabel={'Staðfesta'}
                        cancelLabel={'Hætta við'}
                        invalidDateMessage={''}
                        invalidLabel={''}
                        shouldDisableDate={(date) => {
                            if (
                                !vipDiscount &&
                                this.state.dateStats.filter((d) => d.max).find((d) => moment(d.date).isSame(date, 'day'))
                            ) {
                                return true;
                            }
                            if (
                                moment(date).isSame(new Date('December 24 2023')) ||
                                moment(date).isSame(new Date('December 25 2023'))
                            ) {
                                return true;
                            }
                        }}
                        // minDate={this.state.dates && vipDiscount !== 100 && moment(this.state.dates.blockedFrom)}
                        minDate={new Date()}
                        maxDate={arrivalDate || new Date(`${new Date().getFullYear() + 20}`)}
                        renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
                            if (this.state.dateStats.filter((d) => d.max).find((d) => moment(d.date).isSame(day, 'day'))) {
                                return <Badge badgeContent={'⛔'}>{dayComponent}</Badge>;
                            } else if (
                                this.state.dateStats.filter((d) => d.overload).find((d) => moment(d.date).isSame(day, 'day'))
                            ) {
                                return <Badge badgeContent={'⚠️'}>{dayComponent}</Badge>;
                            } else {
                                return dayComponent;
                            }
                        }}
                    />
                    <TimePicker
                        clearable
                        ampm={false}
                        label="Komutími á leifsstöð"
                        value={departureTime}
                        className="dateInput"
                        onChange={(time) => this.setState({ departureTime: time })}
                        autoOk={true}
                        okLabel={'Staðfesta'}
                        cancelLabel={'Hætta við'}
                        invalidDateMessage={''}
                        invalidLabel={''}
                        minutesStep={5}
                    />
                    <DatePicker
                        label="Heimkomudagur"
                        value={arrivalDate}
                        className="dateInput"
                        onChange={this.setArrivalDate}
                        format={'DD.MM.YYYY'}
                        animateYearScrolling
                        autoOk={true}
                        okLabel={'Staðfesta'}
                        cancelLabel={'Hætta við'}
                        invalidDateMessage={''}
                        invalidLabel={''}
                        shouldDisableDate={(date) => {
                            if (
                                !vipDiscount &&
                                this.state.dateStats.filter((d) => d.maxOut).find((d) => moment(d.date).isSame(date, 'day'))
                            ) {
                                return true;
                            }

                            if (
                                moment(date).isSame(new Date('December 24 2023')) ||
                                moment(date).isSame(new Date('December 25 2023'))
                            ) {
                                return true;
                            }
                        }}
                        minDate={departureDate || new Date()}
                        renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
                            if (this.state.dateStats.filter((d) => d.maxOut).find((d) => moment(d.date).isSame(day, 'day'))) {
                                return <Badge badgeContent={'⛔'}>{dayComponent}</Badge>;
                            } else if (
                                this.state.dateStats.filter((d) => d.overloadOut).find((d) => moment(d.date).isSame(day, 'day'))
                            ) {
                                return <Badge badgeContent={'⚠️'}>{dayComponent}</Badge>;
                            } else {
                                return dayComponent;
                            }
                        }}
                        // shouldDisableDate={(date) => {
                        //   if (moment("December 30 2021").isBefore(date)) {
                        //     return true;
                        //   }
                        //   if (moment("January 8 2022").isAfter(date)) {
                        //     return true;
                        //   }
                        //   return false;
                        // }}
                    />
                    <TimePicker
                        clearable
                        ampm={false}
                        label="Heimkomutími"
                        value={arrivalTime}
                        className="dateInput"
                        onChange={(time) => this.setState({ arrivalTime: time })}
                        autoOk={true}
                        okLabel={'Staðfesta'}
                        cancelLabel={'Hætta við'}
                        invalidDateMessage={''}
                        invalidLabel={''}
                        minutesStep={5}
                    />
                </div>
                <p style={{ width: '100%', marginTop: '20px', textAlign: 'center' }}>
                    Til að viðhalda gæðum og ánægju viðskiptavina höfum við ákveðið að loka fyrir eða leggja álagsgjald á tiltekna
                    daga. Slíkir dagar eru táknaðir ⛔ fyrir lokun og ⚠️ fyrir álag.
                </p>
                <br />
                <Button variant="contained" className={'mainButton'} disabled={!tripValidation} type="submit">
                    Halda áfram
                </Button>
            </form>
        );

        const { price, services, coupon, couponDiscount } = this.state;
        const discount = Math.max(vipDiscount || 0, couponDiscount || 0, clientSenior ? 10 : 0) || 0;

        let couponHelperText = '';
        if (clientSenior && discount === 10) {
            couponHelperText = '10% afsláttur eldri borgara er virkur';
        } else if (vipDiscount && vipDiscount === discount) {
            couponHelperText = `${vipDiscount}% vip afsláttur er virkur`;
        } else if (couponDiscount && couponDiscount === discount) {
            couponHelperText = `Vúhú! Þessi kóði gefur ${couponDiscount}% afslátt!`;
        }

        const serviceForm = (
            <form className="mainForm" onSubmit={this.submitServices}>
                <h2>VIÐBÓTARÞJÓNUSTA</h2>
                <h2 className="floatingTitle">{formatISK(price)}</h2>
                {step}
                <div className="checkBoxGroup">
                    {services
                        .sort((a, b) => a.price - b.price)
                        .map((s, i) => {
                            return (
                                <FormControlLabel
                                    key={s._id}
                                    control={
                                        <Checkbox
                                            checked={s.checked}
                                            onChange={this.handleServiceSelection(i)}
                                            value={i}
                                            color="primary"
                                            className="checkbox"
                                            disabled={
                                                moment(arrivalDate).isAfter(moment('8/6/2023')) &&
                                                moment(arrivalDate).isBefore(moment('8/11/2023')) &&
                                                s.label.toLocaleLowerCase().includes('þrif')
                                            }
                                        />
                                    }
                                    label={
                                        <p>
                                            <b>{s.label}</b> {formatISK(s.price)} {s.daily ? 'aukalega á dag' : ''}
                                        </p>
                                    }
                                />
                            );
                        })}
                    <div className="flexgrow"></div>
                </div>

                <TextField
                    autoFocus
                    label="Afsláttarkóði"
                    placeholder="*****"
                    margin="normal"
                    value={coupon}
                    onChange={(e) => this.handleCouponChange(e.target.value)}
                    helperText={couponHelperText}
                    className="mainInput"
                />

                <div className="checkBoxGroup halfSize">
                    {/* <p className="checkBoxLabel">Afsláttarhópar</p>
                    {
                        discountGroups.map((d, i) =>
                            <FormControlLabel
                                key={i}
                                control={
                                    <Checkbox
                                        checked={d.checked}
                                        onChange={this.handleDiscountSelection(i)}
                                        value={d._id}
                                        color="primary"
                                        className="checkbox"
                                    />
                                }
                                label={(<p>{d.label}</p>)}
                            />
                        )
                    } */}
                    <div className="flexgrow"></div>
                </div>
                {/* <p style={{ width: '100%', marginTop: '20px', textAlign: 'center' }}>
                    ATH: Vertu með símann tilbúinn hjá þér, örugg greiðslugátt Valitor krefst SMS staðfestingar.
                </p> */}
                <br />
                <Button variant="contained" className={'mainButton'} type="submit">
                    Klára Pöntun
                </Button>
            </form>
        );

        let currentForm;
        switch (this.state.step) {
            case 0:
                currentForm = carForm;
                break;
            case 1:
                currentForm = clientForm;
                break;
            case 2:
                currentForm = this.state.dateStats ? (
                    tripForm
                ) : (
                    <div className="loader">
                        <CircularProgress />
                    </div>
                );
                break;
            case 3:
                currentForm = serviceForm;
                break;
            default:
                <h1>404</h1>;
        }

        const reviews = [
            {
                name: 'Guðjón Þór Kristjánsson',
                rating: 5,
                subject:
                    'Frábær þjónusta um leið og við komum upp á Leifsstöð var beðið eftir okkur og bíllinn tekin engin bið og þegar við komum að utan 2 vikum síðar beið starfsmaður Lagningar með bílinn fyrir utan kl ca 10 um kvöld, mjög þægilegt mæli með þessu.',
            },
            {
                name: 'Steina Frímannsdóttir',
                rating: 5,
                subject:
                    'Hef nýtt mér þessa þjónustu nokkrum sinnum og hér eru algjörir snillingar á ferð. Allt stenst eins og stafur á bók, dásamlegt að þurfa hvorki að eyða tíma í að finna bílastæði á leiðinni út né leita að bílnum þegar heim er komið.',
            },
        ];

        const basicServices = [
            {
                label: 'Geymslugjald',
                price: '590 kr. hvern sólarhing ( 5.900 kr. grunngjald )',
            },
            {
                label: 'Innigeymsla',
                price: '990 kr. hvern sólarhing aukalega',
            },
            {
                label: 'Rúðuvökvi',
                price: '1.900 kr.',
            },
            {
                label: 'Fylla eldsneyti ( einungis þjónusta )',
                price: '2.900 kr.',
            },
            {
                label: 'Hlaða rafhlöðu ( einungis þjónusta ) ',
                price: '4.900 kr.',
            },
            {
                label: 'Hraðþrif að utan',
                price: '7.900',
            },
        ];

        const dynamicServices = [
            {
                label: 'Alþrif & Bón',
                price0: '18.900',
                price1: '19.900',
                price2: '20.900',
                price3: '26.900',
            },
            {
                label: 'Þrif að utan & Bón',
                price0: '10.900',
                price1: '11.900',
                price2: '12.900',
                price3: '14.900',
            },
            {
                label: 'Alþrif & Djúphreinsun',
                price0: '27.900',
                price1: '28.900',
                price2: '29.900',
                price3: '35.900',
            },
            {
                label: 'Alþrif & Mössun',
                price0: '59.900',
                price1: '64.900',
                price2: '69.900',
                price3: '89.900',
            },
            {
                label: 'Alþrif & Coat',
                price0: '178.000',
                price1: '198.000',
                price2: '218.000',
                price3: '248.000',
            },
            // {
            //   label: "+ létt mössun",
            //   price0: "66.900",
            //   price1: "72.900",
            //   price2: "78.900",
            //   price3: "92.900",
            // },
        ];

        return (
            <div className="App">
                {/* Order Process */}
                <Header
                    title={'Tryggðu þér snjallt stæði'}
                    subtitle={slogan}
                    concept={concept}
                    logo={logo}
                    cover={cover}
                    trail={bottom}
                />
                {/* <p style={{ width: '800px', maxWidth: 'calc(100% - 40px)', margin: '0 auto', textAlign: 'center' }}>Athugð: Af sökum núverandi ástands er nauðsynlegt að hringja áður en stæði er pantað í síma: 778-5999</p> */}
                {currentForm}
                <Checkout
                    open={this.state.inCheckout}
                    onClose={this.cancelCheckout.bind(this)}
                    order={this.state}
                    updatePrice={this.updatePrice.bind(this)}
                />
                {/* Bio */}
                <Section centered>
                    <p>
                        Lagning er einstaklega snjall kostur fyrir þá sem ætla að leggjast í ferðalög út fyrir landsteinana.
                        Lagning er með fyrsta flokks aðstöðu í skokkfæri við Keflavíkurflugvöll fyrir allar gerðir bíla; allt frá
                        litlum fólksbílum til stærri farartækja.{' '}
                    </p>
                </Section>

                {/* <Section centered>
                    <img src={cover} />
                </Section> */}
                {/* Stats and reviews */}
                <Stats
                    background={cover}
                    title={'Lagning hefur lagt yfir'}
                    value={'20.000'}
                    subtitle={'bílum síðan bílastæðaþjónustan hóf starfsemi sína í Janúar 2018'}
                />
                <Reviews subtitle={''} reviews={reviews} />
                <Images img1={img1} img2={img2} />
                <Section centered>
                    <p>
                        Aðstaða Lagningar er afgirt, læst og vaktað bílaplan í Reykjanesbæ. Starfsmenn Lagningar eru þar á sveimi
                        allan sólarhinginn.
                    </p>
                </Section>
                {/* Pricing */}
                <Section title={'Verðskrá'}>
                    <Pricing title={'Almennt'} data={basicServices} />
                    <Pricing title={'Breytileg Verð'} data={dynamicServices} dynamicSizes={carTypes} />
                </Section>
                {/* Info */}
                <Section centered theme={'bright'}>
                    <p>
                        Með hjálp Lagningar er ekkert því til fyrirstöðu að fljúga í stuttbuxum allan ársins hring. Það er enda
                        aldrei aftur þörf á því að skafa bílrúðurnar eða sópa kílóum af snjó af bifreiðinni þegar þú lendir í
                        Leifsstöð að vetri til.{' '}
                    </p>
                    <p>
                        Starfsmenn Lagningar eru á vakt allan sólarhringinn og fylgjast með því hvenær vélin þín lendir. Við erum
                        með upplýsingar um flugið þitt og vitum hvenær þú snertir íslenska grundu. Þá bíðum við á flugstöðinni og
                        tökum á móti þér fyrir framan brottfarir með bíllyklana tilbúna, sama hvaða tíma sólarhringsins.{' '}
                    </p>
                    <p>Bíllinn bíður svo spenntur eftir þér brottfaramegin við Leifsstöð, oftar en ekki volgur. </p>
                    <br />
                    <p>Lagning notar greiðslugátt Valitor og styður við eftirfarandi kortafyrirtæki:</p>
                    <img src={cards} alt="" style={{ width: '100%' }} />
                    <br />
                    <br />
                    <br />
                    <Link to={'/thjonustuferlid'}>
                        <Button variant="contained" type="button" tabIndex={-1}>
                            Þjónustuferlið í skrefum
                        </Button>
                    </Link>
                </Section>
                {/* Q&A */}
                <Section title={'Spurt og Svarað'} centered theme={'primary'}>
                    <b>Hvernig þekki ég starfsmann Lagningar?</b>
                    <p>
                        Starfsmaður bíður eftir þér við inngang Leifsstöðvar brottfaramegin, þar sem farþegum er skutlað í flug.
                        Þegar þú svo lendir, bíður þín starfsmaður Lagningar fyrir framan inngang brottfara.
                    </p>

                    <b>Hvað ef ég er ekki með upplýsingar um heimkomu?</b>
                    <p>
                        Það eru margir sem skella sér á flugferð aðra leið. Um leið og þú veist hvenær þú ætlar að koma aftur
                        hefurðu samband við okkur í síma 778-5999 eða tölvupósti lagning@lagning.is og gefur okkur upp flugnúmer.
                        Við erum á vakt allan sólarhringinn.{' '}
                    </p>
                    <Link to={'/spurt-og-svarad'}>
                        <Button variant="contained" type="button" tabIndex="-1">
                            Sjá allar spurningar
                        </Button>
                    </Link>
                </Section>
            </div>
        );
    }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/views/LandingPage.js